module.exports = "<div *ngIf=\"group\" class=\"delete-team\">\n  <h4>Are you sure you want to delete {{ group.name }}?</h4>\n  <div class=\"dialogue-actions\">\n  \t<button (click)=\"noConfirm()\" class=\"btn btn-default\">Cancel</button>\n  \t<button (click)=\"deleteGroup()\" class=\"btn btn-danger\">Delete</button> \n \t</div>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/delete-group-confirm/delete-group-confirm.component.html
// module id = ../../../../../src/app/dashboard/program-list/program/groups/delete-group-confirm/delete-group-confirm.component.html
// module chunks = 2